import { create } from "zustand";

export const useStoreUsageBilling = create((set, get) => ({
  usageByProduct: [],
  usageChartResponse: {},

  setUsageByProduct: (data) =>
    set({
      usageByProduct: data?.data,
    }),
  setUsageChart: (data) =>
    set({
      usageChartResponse: data?.data,
    }),
}));
